/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedCommonModule } from "../../common/shared.common.module";
import { DownloadLinkComponent } from "../common/download-link.component";
import { HelpLinkComponent } from "../common/help-link.component";
import { PrivacyLinkComponent } from "../common/privacy-link.component";
import { HeaderComponent } from "../common/header/header.component";
import { FormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { OpenChromeLinkDirective } from "./open-chrome-link.directive";
@NgModule({
   imports: [CommonModule, SharedCommonModule, FormsModule, NgbModule],
   declarations: [
      DownloadLinkComponent,
      HelpLinkComponent,
      PrivacyLinkComponent,
      HeaderComponent,
      OpenChromeLinkDirective
   ],
   exports: [DownloadLinkComponent, HelpLinkComponent, PrivacyLinkComponent, HeaderComponent]
})
export class SharedLauncherCommonModule {}
